import type { IWisDetailsModalRulesProps } from './types'
import WisDetailsModalHeading from './Heading'

export const WisDetailsModalRules = ({ rule }: IWisDetailsModalRulesProps) => {
  return (
    <div>
      <WisDetailsModalHeading isSubHeader>
        {rule.attributeName}
      </WisDetailsModalHeading>
      <div className='bg-gray-100 p-4 rounded-md'>
        {rule.conditions.map((condition, index) => {
          return (
            <div
              key={`${condition.beforeCondition}-${condition.afterCondition}-${index}`}
            >
              {`IF ${rule.attributeName} is ${condition.beforeCondition} `}
              <span className='text-lighthouseBlue'>
                {condition.beforeValue}
              </span>
              {` ${condition.afterCondition} `}
              <span className='text-lighthouseBlue'>
                {condition.afterCondition?.toLowerCase().startsWith('relative')
                  ? condition.afterValue + '%'
                  : condition.afterValue}
              </span>
              <br />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default WisDetailsModalRules
